module.exports = __webpack_public_path__ + "img/2D2D2A_74716E_8F8C8C_92958E-256px.39a0c951.png";